import styled from 'styled-components'
import { Space, Input, InputNumber, Modal } from 'antd'

// Mobile-first, mirroring StyledInsuranceModal in the sibling DHSCheckInsurance feature: full-bleed
// below 768px, restored above it. The restored values are this modal's own (1000px wide, top 20) —
// the sibling is 800px at top 50 and sets a 100vh flex .ant-modal-content, none of which applies
// here, so only the responsive shape is borrowed and not the geometry.
export const StyledApprovalSubmissionModal = styled(Modal)`
  top: 0;
  max-width: 100vw;
  margin: 0;
  padding: 0;
  width: 100% !important;

  @media (min-width: 768px) {
    top: 20px;
    max-width: 1000px;
    width: 1000px !important;
    margin: 0 auto;
  }
`

export const StyledDHSApprovalSubmissionContainer = styled.div`
  display: inline-block;
`

export const StyledApprovalBadge = styled(Space)`
  display: inline-flex;
  align-items: center;
  margin-right: 8px;
`

export const ReadOnlyInput = styled(Input)`
  cursor: not-allowed;

  &.ant-input[readonly] {
    cursor: not-allowed;
  }
`;

export const ReadOnlyInputNumber = styled(InputNumber)`
  cursor: not-allowed;

  .ant-input-number-input {
    cursor: not-allowed;
  }
`;
